function resetPasswordLink(e: MouseEvent) {
  e.preventDefault();

  const returnValue = window.confirm("Are you sure you want to generate a password reset link? This will action will expire any previous password reset links.");
  if (!returnValue) { return; }

  const button = e.target;

  if (!(button instanceof HTMLElement)) { return; }

  const url = button.dataset.generateResetPasswordUrl;

  if (!url) { return; }

  const csrfToken = (document.querySelector("[name=csrf-token]") as HTMLMetaElement).content;

  fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
  })
    .then((response) => {
      if (!response.ok) { throw new Error(`${response.status} response`); }

      return response.json();
    })
    .then((result) => {
      alert(result.reset_url);
    })
    .catch((error) => {
      alert(`Error: ${error.message}`);
    });
}

function readyResetPasswordLink() {
  const resetPasswordButton = document.getElementById("reset_password_button");

  if (!resetPasswordButton) { return; }

  resetPasswordButton.removeEventListener("click", resetPasswordLink);
  resetPasswordButton.addEventListener("click", resetPasswordLink);
}

document.addEventListener("DOMContentLoaded", readyResetPasswordLink);
document.addEventListener("turbo:load", readyResetPasswordLink);
